export default __webpack_public_path__ + "static/Coming-Soon-4-50b023f7043058c7748a724097987cbf.jpg";